/**
 * Every parent-facing string on the Review "proposed update" card
 * (YAR-493), in one place for design / product review. No Figma yet.
 */
import type { ProposalField } from '@/lib/reviewProposal';

export const PROPOSAL_COPY = {
  updateLabel: 'Update',
  cancelLabel: 'Cancel',
  /** Rendered as: "This looks like a change to <b>{title}</b>". */
  updateLead: 'This looks like a change to',
  /** Target could not be loaded — see ProposalView 'unverified'. */
  updateLeadUnverified:
    'This looks like a change to something already on your schedule.',
  cancelLeadUnverified:
    'This looks like a cancellation of something already on your schedule.',
  noChanges: 'Nothing on it changes.',
  cancelEventEffect: 'Confirming removes this event from your schedule.',
  cancelTaskEffect: 'Confirming marks this task as cancelled.',
  /**
   * A cancel whose target is already gone (deleted, or a task already done /
   * cancelled). Confirming changes nothing — see ProposalView 'gone'.
   */
  cancelGone: 'Already removed from your schedule — nothing to do.',
  cancelUnverifiedEffect:
    'Confirming removes it from your schedule, or marks it cancelled if it is a task.',
  keepAsNew: 'Keep as new',
  keepAsNewAria: (title: string) =>
    `Keep "${title}" as a new item instead of updating the existing one`,
  keepAsNewError: "Couldn't keep it as a new item. Please try again.",
  /** Screen-reader words around the struck-through / new value. */
  srBefore: 'Was',
  srAfter: 'now',
  emptyValue: {
    title: 'No title',
    date: 'No date',
    time: 'No time',
    endTime: 'No end time',
    location: 'No location',
    children: 'No one',
  } satisfies Record<ProposalField, string>,
  fieldLabel: {
    title: 'Title',
    date: 'Date',
    time: 'Time',
    endTime: 'Ends',
    location: 'Location',
    children: 'For',
  } satisfies Record<ProposalField, string>,
} as const;
